import React from "react";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import { getTwoWayNumbers } from "./../../Utils/Common";

export default function TwoWayNumberSelector({ checked, onCheckedChange, value, onValueChange }) {
  const longcodes = getTwoWayNumbers();

  if (!longcodes.length) {
    return null;
  }

  return (
    <div style={{ display: "block", width: "100%" }}>
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={() => onCheckedChange(!checked)}
              name="useTwoWayNumber"
              color="primary"
            />
          }
          label="Use a Two-Way SMS Number"
        />
      </FormGroup>
      {checked && (
        <FormControl component="fieldset" style={{ marginLeft: "30px", display: "block" }}>
          <RadioGroup
            name="selectedTwoWayNumber"
            value={value}
            onChange={(event) => onValueChange(event.target.value)}
          >
            {longcodes.map((virtualNumber, i) => (
              <FormControlLabel
                key={i}
                value={virtualNumber.number}
                control={<Radio color="primary" />}
                label={`+${virtualNumber.number} ${JSON.parse(virtualNumber?.credentials)?.label == undefined ? '' : ` - ${JSON.parse(virtualNumber?.credentials)?.label}`}`}
              />
            ))}
          </RadioGroup>
        </FormControl>
      )}
    </div>
  );
}
